import React from "react";
import banner1 from "../assets/images/contact.png";
import UnderCons from "../assets/images/underconstruction.png";
import "remixicon/fonts/remixicon.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

const Contact = () => {
  return (
    <div>
      <div className="banner-two banner-aggregators">
        <img src={banner1} alt="Contact" />
      </div>

      <div className="banner-bottom">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center banner-bottom-text">
                <h4>Contact</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-10 mb-10">
        <div className="container">
          <div className="row">
            {/* Contact Info */}
            <div className="col-md-4 col-sm-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="contact-info-box">
                    <h4>Contact Information</h4>
                    <p>Say something to start a live chat!</p>
                    <br />
                    <br />
                    <address>
                      <i className="ri-phone-line"></i>{" "}
                      <a href="tel:+10123456789">+1 012 3456 789</a>
                      <br />
                      <br />
                      <i className="ri-mail-line"></i>{" "}
                      <a href="mailto:demo@gmail.com">demo@gmail.com</a>
                      <br />
                      <br />
                      <i className="ri-map-pin-line"></i> 132 Dartmouth Street,
                      Boston, Massachusetts 02156, United States
                    </address>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="col-md-8 col-sm-12">
              <form className="c-floating-form">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingFirstName"
                        placeholder="First Name"
                      />
                      <label htmlFor="floatingFirstName">First Name</label>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingLastName"
                        placeholder="Last Name"
                      />
                      <label htmlFor="floatingLastName">Last Name</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="Email"
                        placeholder="Email"
                      />
                      <label htmlFor="Email">Email</label>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Phone"
                        placeholder="Phone"
                      />
                      <label htmlFor="Phone">Phone</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <h6>Select Subject?</h6>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox1"
                        value="option1"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineCheckbox1"
                      >
                        Recruiter Inquiry
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox2"
                        value="option2"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineCheckbox2"
                      >
                        Aggregators Inquiry
                      </label>
                    </div>

                    {/* Example disabled checkbox */}
                    {/*
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="inlineCheckbox3"
                        value="option3"
                        disabled
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineCheckbox3"
                      >
                        3 (disabled)
                      </label>
                    </div>
                    */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="form-floating mb-3">
                      <textarea
                        className="form-control"
                        id="Message"
                        rows={10}
                        placeholder="Message"
                      ></textarea>
                      <label htmlFor="Message">Message</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 col-sm-12 text-end">
                    <button type="submit" className="btn cff-send">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
